module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1319/plan1-2-fdb3acab85b2d69d669cb908d760d5c4.webp";